import { AdminLayout } from "layout/AdminLayout"
import { AdminUpdateCategoriesComponent } from "components/admin/categories/UpdateCategories";

export const AdminCategoriesPage = () => {

    return (
        <AdminLayout>
            <AdminUpdateCategoriesComponent />
        </AdminLayout>
    )
}